import { render, staticRenderFns } from "./ISharedFolderPicker.vue?vue&type=template&id=c8c754f6"
import script from "./ISharedFolderPicker.vue?vue&type=script&lang=js"
export * from "./ISharedFolderPicker.vue?vue&type=script&lang=js"
import style0 from "./ISharedFolderPicker.vue?vue&type=style&index=0&id=c8c754f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports